// @flow
import Api, { apiTypes } from 'app/common/api';

// DEPRECATED
// это не нужно использовать. Оно для совместимости
// Нужно использовать app/api

const api: Api = new Api(apiTypes.API_GENERAL);
const axiosWHeaders = api.commonRequest.bind(api);

export default axiosWHeaders;
